import { inject, Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { WebStorage } from "./web-storage";

@Injectable({
  providedIn: "root",
})
export class ProductFamilyFilterService {
  private webStorage = inject(WebStorage);

  // BehaviorSubject holds the current excluded IDs
  private excludedIdsSubject = new BehaviorSubject<string[]>(
    this.webStorage.productFamilyIdsExcluded ?? [],
  );
  // Observable for components to subscribe to
  excludedIds$ = this.excludedIdsSubject.asObservable();

  getIdsExcluded() {
    return this.excludedIds$;
  }

  setIdsExcluded(ids: string[]) {
    this.webStorage.productFamilyIdsExcluded = ids ?? [];
    this.excludedIdsSubject.next(this.webStorage.productFamilyIdsExcluded);
  }

  remove(id: string) {
    if (id) {
      this.setIdsExcluded(
        this.webStorage.productFamilyIdsExcluded.filter(
          (excludedId) => excludedId !== id,
        ),
      );
    }
  }

  add(id: string) {
    if (id) {
      const excludedIds = this.webStorage.productFamilyIdsExcluded;
      if (!excludedIds.includes(id)) {
        this.setIdsExcluded([...excludedIds, id]);
      }
    }
  }
}
